import { Box, CircularProgress, Typography } from '@mui/material';
import RouletteContentDailyCountChart from '../../../../components/pointhome/roulette/content/RouletteContentDailyCountChart';
import RouletteContentDailyCountTable from '../../../../components/pointhome/roulette/content/RouletteContentDailyCountTable';
import RouletteContentTimeParticipationChart from '../../../../components/pointhome/roulette/content/RouletteContentTimeParticipationChart';
import RouletteContentTimeParticipationTable from '../../../../components/pointhome/roulette/content/RouletteContentTimeParticipationTable';
import RouletteContentTicketAcquisitionCharts from '../../../../components/pointhome/roulette/content/RouletteContentTicketAcquisitionCharts';
import RouletteContentUserStatusChart from '../../../../components/pointhome/roulette/content/RouletteContentUserStatusChart';
import type { UserStatusDatum } from '../../../../components/pointhome/roulette/content/RouletteContentUserStatusChart';
import type { TimeParticipationTableRow } from '../../../../components/pointhome/roulette/content/RouletteContentTimeParticipationTable';
import type { DailyCountDatum } from '../../../../components/pointhome/roulette/content/RouletteContentDailyCountChart';
import type { DailyCountTableRow } from '../../../../components/pointhome/roulette/content/RouletteContentDailyCountTable';
import type { TicketAcquisitionDatum } from '../../../../components/pointhome/roulette/content/RouletteContentTicketAcquisitionCharts';

type Props = {
  contentTab: number;
  loading: boolean;
  error: string | null;
  userStatusChartData?: UserStatusDatum[];
  ticketAcquisitionData?: TicketAcquisitionDatum[];
  timeChartData?: { timeRange: string; value: number }[];
  timeTableRows?: TimeParticipationTableRow[];
  dailyChartData?: DailyCountDatum[];
  dailyCountColumnLabels?: string[];
  dailyTableRows?: DailyCountTableRow[];
};

export default function TabGeneral({
  contentTab,
  loading,
  error,
  userStatusChartData,
  ticketAcquisitionData,
  timeChartData,
  timeTableRows,
  dailyChartData,
  dailyCountColumnLabels,
  dailyTableRows,
}: Props) {
  if (error) {
    return (
      <Typography color="error" variant="body2" sx={{ mb: 2 }}>
        {error}
      </Typography>
    );
  }
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  const isScoopTab = contentTab === 1;
  // 홈 방문하기(8)만 제외하고 나머지(낚시류 + 랜덤/광고보기/영상 광고)는 상위 3개를 강조한다.
  const highlightTop3 = contentTab !== 8;

  return (
    <>
      <RouletteContentUserStatusChart data={userStatusChartData} />

      {isScoopTab && (
        <Box
          sx={{
            mt: 3,
            border: '1px solid #e5e7eb',
            borderRadius: 3,
            overflow: 'hidden',
            backgroundColor: '#ffffff',
            p: 2,
          }}
        >
          <RouletteContentTicketAcquisitionCharts ticketData={ticketAcquisitionData} />
        </Box>
      )}

      <Box
        sx={{
          mt: 3,
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'stretch',
        }}
      >
        <Box
          sx={{
            flex: '1 1 50%',
            minWidth: 0,
            border: '1px solid #e5e7eb',
            borderRadius: 3,
            overflow: 'hidden',
            backgroundColor: '#ffffff',
          }}
        >
          <RouletteContentTimeParticipationChart data={timeChartData} />
          <RouletteContentTimeParticipationTable rows={timeTableRows} />
        </Box>
        <Box
          sx={{
            flex: '1 1 50%',
            minWidth: 0,
            border: '1px solid #e5e7eb',
            borderRadius: 3,
            overflow: 'hidden',
            backgroundColor: '#ffffff',
          }}
        >
          <RouletteContentDailyCountChart data={dailyChartData} highlightTop3={highlightTop3} />
          <RouletteContentDailyCountTable
            columnLabels={dailyCountColumnLabels}
            rows={dailyTableRows}
          />
        </Box>
      </Box>
    </>
  );
}
